import { ref } from "vue";
import type { Ref } from "vue";

export interface ITblMServiceData {
  pkCompanyCode?: string;
  pkOfficeCode?: string;
  pkServiceType?: string;
  serviceType?: string;
  serviceCode?: string;
  serviceName?: string | any;
  serviceId?: number;
  hokenCode?: string;
  memo?: string;
  kaisibi?: string;
  shuryobi?: string;
  serviceCount?: number;
  serviceRyaku?: string | any;
  henkobi?: Date | null;
  newServiceCount?: number;
  santeiTime?: number;
  countKbn?: number;
  newServiceName?: string;
  countSantei?: number;
  kizamiLow?: number;
  goseiKbn?: number;
  kizamiHigh?: number;
  kizamiHaba?: number;
  kizamiTani?: number;
  kizamiCount?: number;
  yobi1?: string;
  yobi2?: string;
  yobi3?: string;
  yobi4?: string;
  yobi5?: string;
  sisetuKbn?: string;
  shokuinKbn?: number;
  gaitoKbn?: number;
  keikaKaigo?: number;
  kaigoRank1?: number;
  kaigoRank2?: number;
  kaigoRank3?: number;
  kaigoRank4?: number;
  kaigoRank5?: number;
  kyusotiKbn?: number;
  hihokenKbn1?: string;
  hihokenKbn2?: string;
  hihokenKbn3?: string;
  hihokenKbn4?: string;
  hihokenKbn5?: string;
  naiyoKbn?: number;
  sikakuKbn?: string;
  shoyoJikans?: number;
  shoyoJikane?: number;
  baseCode?: string;
  chukagenCode1?: string;
  chukagenCode2?: string;
  chukagenCode3?: string;
  chukagenCode4?: string;
  chukagenCode5?: string;
  chukagenCode6?: string;
  chukagenCode7?: string;
  chukagenCode8?: string;
  chukagenCode9?: string;
  chukagenCode10?: string;
  chukagenYobi1?: string;
  chukagenYobi2?: string;
  chukagenYobi3?: string;
  chukagenYobi4?: string;
  chukagenYobi5?: string;
  chukagenYobi6?: string;
  chukagenYobi7?: string;
  chukagenYobi8?: string;
  chukagenYobi9?: string;
  chukagenYobi10?: string;
  kasanCode1?: string;
  kasanCode2?: string;
  kasanCode3?: string;
  kasanCode4?: string;
  kasanCode5?: string;
  kasanCode6?: string;
  kasanCode7?: string;
  kasanCode8?: string;
  kasanCode9?: string;
  kasanCode10?: string;
  kasanYobi1?: string;
  kasanYobi2?: string;
  kasanYobi3?: string;
  kasanYobi4?: string;
  kasanYobi5?: string;
  kasanYobi6?: string;
  kasanYobi7?: string;
  kasanYobi8?: string;
  kasanYobi9?: string;
  kasanYobi10?: string;
  tekiyoJoken?: number;
  gendotaishoKbn?: number;
  santeiJiki?: number;
  santeiNissu?: number;
  tikiKbn?: number;
  kinkyuKbn?: number;
  kanriKbn?: number;
  kinoKbn?: number;
  shokujiKbn?: number;
  nyuyokuKbn?: number;
  tokuNyoyokuKbn?: number;
  rihaKbn?: number;
  kijunKbn?: number;
  h10Kbn?: number;
  jokinDoctor?: number;
  kinmuKbn?: number;
  doctorKeika?: number;
  seisinShodo?: number;
  yakinKbn?: number;
  tihotoKbn?: number;
  shokujiKanri?: number;
  tokuShokujiKbn?: number;
  sogeiKbn?: number;
  jigyoSiteiYobi1?: number;
  jigyoSiteiYobi2?: number;
  jigyoSiteiYobi3?: number;
  jigyoSiteiYobi4?: number;
  jigyoSiteiYobi5?: number;
  jigyoSiteiYobi6?: number;
  jigyoSiteiYobi7?: number;
  jigyoSiteiYobi8?: number;
  jigyoSiteiYobi9?: number;
  jigyoSiteiYobi10?: number;
  kohiBango1?: number;
  kohiBango2?: number;
  kohiBango3?: number;
  kohiBango4?: number;
  kohiBango5?: number;
  kohiBango6?: number;
  kohiBango7?: number;
  kohiBango8?: number;
  kohiBango9?: number;
  kohiBango10?: number;
  kohiYobi1?: number;
  kohiYobi2?: number;
  kohiYobi3?: number;
  kohiYobi4?: number;
  kohiYobi5?: number;
  kohiYobi6?: number;
  kohiYobi7?: number;
  kohiYobi8?: number;
  kohiYobi9?: number;
  kohiYobi10?: number;
  countSho?: number;
  countBu?: string;
  countEda?: string;
  countSetu?: string;
  countKo1?: number;
  countKo2?: number;
  keikaDate?: Date | null;
  serviceRiyo?: number;
  userCnt?: number;
  jigyoshoGen?: number;
  serviceGaibu?: number;
  jigyoshoDai?: number;
  needSien1?: number;
  needSien2?: number;
  homonJigyoKbn?: number;
  terminalKbn?: number;
  eiyoKbn?: number;
  koukouKbn?: number;
  jakunenKbn?: number;
  ukeireKbn?: number;
  yakanKbn?: number;
  jigyoshoKasan?: number;
  unitcareKbn?: number;
  judoKbn?: number;
  junUnitKbn?: number;
  yobi159?: number;
  kosokuHaisiKbn?: number;
  sogoRiyoKbn?: number;
  undoKbn?: number;
  jigyoHyokaKbn?: number;
  renkeiKbn?: number;
  shokiboKbn?: number;
  kasanCode21?: string;
  kasanCode22?: string;
  kasanCode23?: string;
  kasanCode24?: string;
  kasanCode25?: string;
  kasanCode26?: string;
  kasanCode27?: string;
  kasanCode28?: string;
  kasanCode29?: string;
  kasanCode30?: string;
  seiyakuKbn?: number;
  serviceKbn?: number;
  hiwariKbn?: number;
  yobi179?: number;
  nintiCareKbn?: number;
  kunrenKbn?: number;
  homonNinzu?: number;
  siKasan1?: number;
  keiTani1?: number;
  siKasan2?: number;
  keiTani2?: number;
  siKasan3?: number;
  keiTani3?: number;
  setubi?: string;
  ryoyoToku?: string;
  kasanCode31?: string;
  kasanCode32?: string;
  kasanCode33?: string;
  kasanCode34?: string;
  kasanCode35?: string;
  kasanCode36?: string;
  kasanCode37?: string;
  kasanCode38?: string;
  kasanCode39?: string;
  kasanCode40?: string;
  kasanCode41?: string;
  kasanCode42?: string;
  kasanCode43?: string;
  kasanCode44?: string;
  kasanCode45?: string;
  sankyuTaisei?: string;
  tikiJokyo?: string;
  kiboJokyo?: string;
  teikyoTaisei?: string;
  ninchiRiha?: string;
  jyakunensei?: string;
  kangoTaisei?: string;
  yakinHaichi?: string;
  ryoyoshoku?: string;
  yobi215?: string;
  yobi216?: string;
  keizokuSien?: string;
  ninchiCare?: string;
  tuhoTaio?: string;
  kangoHaichi?: string;
  yakanKea?: string;
  chuzanTeikyo?: string;
  siKasan4?: number;
  keiTani4?: number;
  siKasan5?: number;
  keiTani5?: number;
  siKasan6?: number;
  keiTani6?: number;
  siKasan7?: number;
  keiTani7?: number;
  siKasan8?: number;
  keiTani8?: number;
  siKasan9?: number;
  keiTani9?: number;
  siKasan10?: number;
  keiTani10?: number;
  dokujiHoshu?: number;
  jogenTani?: number;
  kasanCode46?: string;
  kasanCode47?: string;
  kasanCode48?: string;
  kasanCode49?: string;
  kasanCode50?: string;
  kasanCode51?: string;
  kasanCode52?: string;
  kasanCode53?: string;
  kasanCode54?: string;
  kasanCode55?: string;
  sekininsha?: string;
  kinkyuTanki?: string;
  yobi251?: string;
  fukkiSien?: string;
  kinoKojo?: string;
  shogu?: string;
  miman?: string;
  tatemono?: string;
  shoguTani?: number;
  shoguKbn?: string;
  sogoJigyoRuikei?: string;
  hiHokenSogoTaisyo?: string;
  sogoJigyoKbn?: string;
  sogoJigyoHenKbn?: string;
  sogoJigyoFutanKbn?: string;
  rihaMgKbn?: string;
  kangoTaiseiKbn?: string;
  tankiRihaKbn?: string;
  syakaiSankaKbn?: string;
  nintishoKasanKbn?: string;
  chudosyaCareKbn?: string;
  kobetuSogeiKbn?: string;
  nyuyokuKaijyoKbn?: string;
  yob272?: string;
  seikatuKouiKbn?: string;
  yob274?: string;
  yob275?: string;
  iryoRenkei?: string;
  yob277?: string;
  tokuteiGenKbn?: string;
  yob279?: string;
  yob280?: string;
  yob281?: string;
  yob282?: string;
  yob283?: string;
  sentakuHukuKbn?: string;
  sogoMgKbn?: string;
  yob286?: string;
  yob287?: string;
  mitoriKbn?: string;
  homonTaiseiKbn?: string;
  yakanTaiseiKbn?: string;
  kangoGenKbn?: string;
  kangoKyokaKbn?: string;
  yob293?: string;
  yob294?: string;
  yob295?: string;
  yob296?: string;
  yob297?: string;
  yob298?: string;
  yob299?: string;
  yob300?: string;
  douituGen?: string;
  pkSystemCode?: number;
  isSelect?: boolean;
}

export class TblMService {
  pkCompanyCode?: string;
  pkOfficeCode?: string;
  pkServiceType?: string;
  serviceType?: string;
  serviceCode?: string;
  serviceName?: string | any;
  serviceId?: number;
  hokenCode?: string;
  memo?: string;
  kaisibi?: string | any;
  shuryobi?: string | any;
  serviceCount?: number;
  serviceRyaku?: string | any;
  henkobi?: Date | null;
  newServiceCount?: number;
  santeiTime?: number;
  countKbn?: number;
  newServiceName?: string;
  countSantei?: number;
  kizamiLow?: number;
  goseiKbn?: number;
  kizamiHigh?: number;
  kizamiHaba?: number;
  kizamiTani?: number;
  kizamiCount?: number;
  yobi1?: string;
  yobi2?: string;
  yobi3?: string;
  yobi4?: string;
  yobi5?: string;
  sisetuKbn?: string;
  shokuinKbn?: number;
  gaitoKbn?: number;
  keikaKaigo?: number;
  kaigoRank1?: number;
  kaigoRank2?: number;
  kaigoRank3?: number;
  kaigoRank4?: number;
  kaigoRank5?: number;
  kyusotiKbn?: number;
  hihokenKbn1?: string;
  hihokenKbn2?: string;
  hihokenKbn3?: string;
  hihokenKbn4?: string;
  hihokenKbn5?: string;
  naiyoKbn?: number;
  sikakuKbn?: string;
  shoyoJikans?: number;
  shoyoJikane?: number;
  baseCode?: string;
  chukagenCode1?: string;
  chukagenCode2?: string;
  chukagenCode3?: string;
  chukagenCode4?: string;
  chukagenCode5?: string;
  chukagenCode6?: string;
  chukagenCode7?: string;
  chukagenCode8?: string;
  chukagenCode9?: string;
  chukagenCode10?: string;
  chukagenYobi1?: string;
  chukagenYobi2?: string;
  chukagenYobi3?: string;
  chukagenYobi4?: string;
  chukagenYobi5?: string;
  chukagenYobi6?: string;
  chukagenYobi7?: string;
  chukagenYobi8?: string;
  chukagenYobi9?: string;
  chukagenYobi10?: string;
  kasanCode1?: string;
  kasanCode2?: string;
  kasanCode3?: string;
  kasanCode4?: string;
  kasanCode5?: string;
  kasanCode6?: string;
  kasanCode7?: string;
  kasanCode8?: string;
  kasanCode9?: string;
  kasanCode10?: string;
  kasanYobi1?: string;
  kasanYobi2?: string;
  kasanYobi3?: string;
  kasanYobi4?: string;
  kasanYobi5?: string;
  kasanYobi6?: string;
  kasanYobi7?: string;
  kasanYobi8?: string;
  kasanYobi9?: string;
  kasanYobi10?: string;
  tekiyoJoken?: number;
  gendotaishoKbn?: number;
  santeiJiki?: number;
  santeiNissu?: number;
  tikiKbn?: number;
  kinkyuKbn?: number;
  kanriKbn?: number;
  kinoKbn?: number;
  shokujiKbn?: number;
  nyuyokuKbn?: number;
  tokuNyoyokuKbn?: number;
  rihaKbn?: number;
  kijunKbn?: number;
  h10Kbn?: number;
  jokinDoctor?: number;
  kinmuKbn?: number;
  doctorKeika?: number;
  seisinShodo?: number;
  yakinKbn?: number;
  tihotoKbn?: number;
  shokujiKanri?: number;
  tokuShokujiKbn?: number;
  sogeiKbn?: number;
  jigyoSiteiYobi1?: number;
  jigyoSiteiYobi2?: number;
  jigyoSiteiYobi3?: number;
  jigyoSiteiYobi4?: number;
  jigyoSiteiYobi5?: number;
  jigyoSiteiYobi6?: number;
  jigyoSiteiYobi7?: number;
  jigyoSiteiYobi8?: number;
  jigyoSiteiYobi9?: number;
  jigyoSiteiYobi10?: number;
  kohiBango1?: number;
  kohiBango2?: number;
  kohiBango3?: number;
  kohiBango4?: number;
  kohiBango5?: number;
  kohiBango6?: number;
  kohiBango7?: number;
  kohiBango8?: number;
  kohiBango9?: number;
  kohiBango10?: number;
  kohiYobi1?: number;
  kohiYobi2?: number;
  kohiYobi3?: number;
  kohiYobi4?: number;
  kohiYobi5?: number;
  kohiYobi6?: number;
  kohiYobi7?: number;
  kohiYobi8?: number;
  kohiYobi9?: number;
  kohiYobi10?: number;
  countSho?: number;
  countBu?: string;
  countEda?: string;
  countSetu?: string;
  countKo1?: number;
  countKo2?: number;
  keikaDate?: Date | null;
  serviceRiyo?: number;
  userCnt?: number;
  jigyoshoGen?: number;
  serviceGaibu?: number;
  jigyoshoDai?: number;
  needSien1?: number;
  needSien2?: number;
  homonJigyoKbn?: number;
  terminalKbn?: number;
  eiyoKbn?: number;
  koukouKbn?: number;
  jakunenKbn?: number;
  ukeireKbn?: number;
  yakanKbn?: number;
  jigyoshoKasan?: number;
  unitcareKbn?: number;
  judoKbn?: number;
  junUnitKbn?: number;
  yobi159?: number;
  kosokuHaisiKbn?: number;
  sogoRiyoKbn?: number;
  undoKbn?: number;
  jigyoHyokaKbn?: number;
  renkeiKbn?: number;
  shokiboKbn?: number;
  kasanCode21?: string;
  kasanCode22?: string;
  kasanCode23?: string;
  kasanCode24?: string;
  kasanCode25?: string;
  kasanCode26?: string;
  kasanCode27?: string;
  kasanCode28?: string;
  kasanCode29?: string;
  kasanCode30?: string;
  seiyakuKbn?: number;
  serviceKbn?: number;
  hiwariKbn?: number;
  yobi179?: number;
  nintiCareKbn?: number;
  kunrenKbn?: number;
  homonNinzu?: number;
  siKasan1?: number;
  keiTani1?: number;
  siKasan2?: number;
  keiTani2?: number;
  siKasan3?: number;
  keiTani3?: number;
  setubi?: string;
  ryoyoToku?: string;
  kasanCode31?: string;
  kasanCode32?: string;
  kasanCode33?: string;
  kasanCode34?: string;
  kasanCode35?: string;
  kasanCode36?: string;
  kasanCode37?: string;
  kasanCode38?: string;
  kasanCode39?: string;
  kasanCode40?: string;
  kasanCode41?: string;
  kasanCode42?: string;
  kasanCode43?: string;
  kasanCode44?: string;
  kasanCode45?: string;
  sankyuTaisei?: string;
  tikiJokyo?: string;
  kiboJokyo?: string;
  teikyoTaisei?: string;
  ninchiRiha?: string;
  jyakunensei?: string;
  kangoTaisei?: string;
  yakinHaichi?: string;
  ryoyoshoku?: string;
  yobi215?: string;
  yobi216?: string;
  keizokuSien?: string;
  ninchiCare?: string;
  tuhoTaio?: string;
  kangoHaichi?: string;
  yakanKea?: string;
  chuzanTeikyo?: string;
  siKasan4?: number;
  keiTani4?: number;
  siKasan5?: number;
  keiTani5?: number;
  siKasan6?: number;
  keiTani6?: number;
  siKasan7?: number;
  keiTani7?: number;
  siKasan8?: number;
  keiTani8?: number;
  siKasan9?: number;
  keiTani9?: number;
  siKasan10?: number;
  keiTani10?: number;
  dokujiHoshu?: number;
  jogenTani?: number;
  kasanCode46?: string;
  kasanCode47?: string;
  kasanCode48?: string;
  kasanCode49?: string;
  kasanCode50?: string;
  kasanCode51?: string;
  kasanCode52?: string;
  kasanCode53?: string;
  kasanCode54?: string;
  kasanCode55?: string;
  sekininsha?: string;
  kinkyuTanki?: string;
  yobi251?: string;
  fukkiSien?: string;
  kinoKojo?: string;
  shogu?: string;
  miman?: string;
  tatemono?: string;
  shoguTani?: number;
  shoguKbn?: string;
  sogoJigyoRuikei?: string;
  hiHokenSogoTaisyo?: string;
  sogoJigyoKbn?: string;
  sogoJigyoHenKbn?: string;
  sogoJigyoFutanKbn?: string;
  rihaMgKbn?: string;
  kangoTaiseiKbn?: string;
  tankiRihaKbn?: string;
  syakaiSankaKbn?: string;
  nintishoKasanKbn?: string;
  chudosyaCareKbn?: string;
  kobetuSogeiKbn?: string;
  nyuyokuKaijyoKbn?: string;
  yob272?: string;
  seikatuKouiKbn?: string;
  yob274?: string;
  yob275?: string;
  iryoRenkei?: string;
  yob277?: string;
  tokuteiGenKbn?: string;
  yob279?: string;
  yob280?: string;
  yob281?: string;
  yob282?: string;
  yob283?: string;
  sentakuHukuKbn?: string;
  sogoMgKbn?: string;
  yob286?: string;
  yob287?: string;
  mitoriKbn?: string;
  homonTaiseiKbn?: string;
  yakanTaiseiKbn?: string;
  kangoGenKbn?: string;
  kangoKyokaKbn?: string;
  yob293?: string;
  yob294?: string;
  yob295?: string;
  yob296?: string;
  yob297?: string;
  yob298?: string;
  yob299?: string;
  yob300?: string;
  douituGen?: string;
  pkSystemCode?: number;
  isSelect?: boolean;

  constructor(data: ITblMServiceData = {}) {
    this.pkCompanyCode = data.pkCompanyCode || "";
    this.pkOfficeCode = data.pkOfficeCode || "";
    this.pkServiceType = data.pkServiceType || "";
    this.serviceType = data.serviceType || "";
    this.serviceCode = data.serviceCode || "";
    this.serviceName = data.serviceName || "";
    this.serviceId = data.serviceId || 0;
    this.hokenCode = data.hokenCode || "";
    this.memo = data.memo || "";
    this.kaisibi = data.kaisibi || "";
    this.shuryobi = data.shuryobi || "";
    this.serviceCount = data.serviceCount || 0;
    this.serviceRyaku = data.serviceRyaku || "";
    this.henkobi = data.henkobi || null;
    this.newServiceCount = data.newServiceCount || 0;
    this.santeiTime = data.santeiTime || 0;
    this.countKbn = data.countKbn || 0;
    this.newServiceName = data.newServiceName || "";
    this.countSantei = data.countSantei || 0;
    this.kizamiLow = data.kizamiLow || 0;
    this.goseiKbn = data.goseiKbn || 0;
    this.kizamiHigh = data.kizamiHigh || 0;
    this.kizamiHaba = data.kizamiHaba || 0;
    this.kizamiTani = data.kizamiTani || 0;
    this.kizamiCount = data.kizamiCount || 0;
    this.yobi1 = data.yobi1 || "";
    this.yobi2 = data.yobi2 || "";
    this.yobi3 = data.yobi3 || "";
    this.yobi4 = data.yobi4 || "";
    this.yobi5 = data.yobi5 || "";
    this.sisetuKbn = data.sisetuKbn || "";
    this.shokuinKbn = data.shokuinKbn || 0;
    this.gaitoKbn = data.gaitoKbn || 0;
    this.keikaKaigo = data.keikaKaigo || 0;
    this.kaigoRank1 = data.kaigoRank1 || 0;
    this.kaigoRank2 = data.kaigoRank2 || 0;
    this.kaigoRank3 = data.kaigoRank3 || 0;
    this.kaigoRank4 = data.kaigoRank4 || 0;
    this.kaigoRank5 = data.kaigoRank5 || 0;
    this.kyusotiKbn = data.kyusotiKbn || 0;
    this.hihokenKbn1 = data.hihokenKbn1 || "";
    this.hihokenKbn2 = data.hihokenKbn2 || "";
    this.hihokenKbn3 = data.hihokenKbn3 || "";
    this.hihokenKbn4 = data.hihokenKbn4 || "";
    this.hihokenKbn5 = data.hihokenKbn5 || "";
    this.naiyoKbn = data.naiyoKbn || 0;
    this.sikakuKbn = data.sikakuKbn || "";
    this.shoyoJikans = data.shoyoJikans || 0;
    this.shoyoJikane = data.shoyoJikane || 0;
    this.baseCode = data.baseCode || "";
    this.chukagenCode1 = data.chukagenCode1 || "";
    this.chukagenCode2 = data.chukagenCode2 || "";
    this.chukagenCode3 = data.chukagenCode3 || "";
    this.chukagenCode4 = data.chukagenCode4 || "";
    this.chukagenCode5 = data.chukagenCode5 || "";
    this.chukagenCode6 = data.chukagenCode6 || "";
    this.chukagenCode7 = data.chukagenCode7 || "";
    this.chukagenCode8 = data.chukagenCode8 || "";
    this.chukagenCode9 = data.chukagenCode9 || "";
    this.chukagenCode10 = data.chukagenCode10 || "";
    this.chukagenYobi1 = data.chukagenYobi1 || "";
    this.chukagenYobi2 = data.chukagenYobi2 || "";
    this.chukagenYobi3 = data.chukagenYobi3 || "";
    this.chukagenYobi4 = data.chukagenYobi4 || "";
    this.chukagenYobi5 = data.chukagenYobi5 || "";
    this.chukagenYobi6 = data.chukagenYobi6 || "";
    this.chukagenYobi7 = data.chukagenYobi7 || "";
    this.chukagenYobi8 = data.chukagenYobi8 || "";
    this.chukagenYobi9 = data.chukagenYobi9 || "";
    this.chukagenYobi10 = data.chukagenYobi10 || "";
    this.kasanCode1 = data.kasanCode1 || "";
    this.kasanCode2 = data.kasanCode2 || "";
    this.kasanCode3 = data.kasanCode3 || "";
    this.kasanCode4 = data.kasanCode4 || "";
    this.kasanCode5 = data.kasanCode5 || "";
    this.kasanCode6 = data.kasanCode6 || "";
    this.kasanCode7 = data.kasanCode7 || "";
    this.kasanCode8 = data.kasanCode8 || "";
    this.kasanCode9 = data.kasanCode9 || "";
    this.kasanCode10 = data.kasanCode10 || "";
    this.kasanYobi1 = data.kasanYobi1 || "";
    this.kasanYobi2 = data.kasanYobi2 || "";
    this.kasanYobi3 = data.kasanYobi3 || "";
    this.kasanYobi4 = data.kasanYobi4 || "";
    this.kasanYobi5 = data.kasanYobi5 || "";
    this.kasanYobi6 = data.kasanYobi6 || "";
    this.kasanYobi7 = data.kasanYobi7 || "";
    this.kasanYobi8 = data.kasanYobi8 || "";
    this.kasanYobi9 = data.kasanYobi9 || "";
    this.kasanYobi10 = data.kasanYobi10 || "";
    this.tekiyoJoken = data.tekiyoJoken || 0;
    this.gendotaishoKbn = data.gendotaishoKbn || 0;
    this.santeiJiki = data.santeiJiki || 0;
    this.santeiNissu = data.santeiNissu || 0;
    this.tikiKbn = data.tikiKbn || 0;
    this.kinkyuKbn = data.kinkyuKbn || 0;
    this.kanriKbn = data.kanriKbn || 0;
    this.kinoKbn = data.kinoKbn || 0;
    this.shokujiKbn = data.shokujiKbn || 0;
    this.nyuyokuKbn = data.nyuyokuKbn || 0;
    this.tokuNyoyokuKbn = data.tokuNyoyokuKbn || 0;
    this.rihaKbn = data.rihaKbn || 0;
    this.kijunKbn = data.kijunKbn || 0;
    this.h10Kbn = data.h10Kbn || 0;
    this.jokinDoctor = data.jokinDoctor || 0;
    this.kinmuKbn = data.kinmuKbn || 0;
    this.doctorKeika = data.doctorKeika || 0;
    this.seisinShodo = data.seisinShodo || 0;
    this.yakinKbn = data.yakinKbn || 0;
    this.tihotoKbn = data.tihotoKbn || 0;
    this.shokujiKanri = data.shokujiKanri || 0;
    this.tokuShokujiKbn = data.tokuShokujiKbn || 0;
    this.sogeiKbn = data.sogeiKbn || 0;
    this.jigyoSiteiYobi1 = data.jigyoSiteiYobi1 || 0;
    this.jigyoSiteiYobi2 = data.jigyoSiteiYobi2 || 0;
    this.jigyoSiteiYobi3 = data.jigyoSiteiYobi3 || 0;
    this.jigyoSiteiYobi4 = data.jigyoSiteiYobi4 || 0;
    this.jigyoSiteiYobi5 = data.jigyoSiteiYobi5 || 0;
    this.jigyoSiteiYobi6 = data.jigyoSiteiYobi6 || 0;
    this.jigyoSiteiYobi7 = data.jigyoSiteiYobi7 || 0;
    this.jigyoSiteiYobi8 = data.jigyoSiteiYobi8 || 0;
    this.jigyoSiteiYobi9 = data.jigyoSiteiYobi9 || 0;
    this.jigyoSiteiYobi10 = data.jigyoSiteiYobi10 || 0;
    this.kohiBango1 = data.kohiBango1 || 0;
    this.kohiBango2 = data.kohiBango2 || 0;
    this.kohiBango3 = data.kohiBango3 || 0;
    this.kohiBango4 = data.kohiBango4 || 0;
    this.kohiBango5 = data.kohiBango5 || 0;
    this.kohiBango6 = data.kohiBango6 || 0;
    this.kohiBango7 = data.kohiBango7 || 0;
    this.kohiBango8 = data.kohiBango8 || 0;
    this.kohiBango9 = data.kohiBango9 || 0;
    this.kohiBango10 = data.kohiBango10 || 0;
    this.kohiYobi1 = data.kohiYobi1 || 0;
    this.kohiYobi2 = data.kohiYobi2 || 0;
    this.kohiYobi3 = data.kohiYobi3 || 0;
    this.kohiYobi4 = data.kohiYobi4 || 0;
    this.kohiYobi5 = data.kohiYobi5 || 0;
    this.kohiYobi6 = data.kohiYobi6 || 0;
    this.kohiYobi7 = data.kohiYobi7 || 0;
    this.kohiYobi8 = data.kohiYobi8 || 0;
    this.kohiYobi9 = data.kohiYobi9 || 0;
    this.kohiYobi10 = data.kohiYobi10 || 0;
    this.countSho = data.countSho || 0;
    this.countBu = data.countBu || "";
    this.countEda = data.countEda || "";
    this.countSetu = data.countSetu || "";
    this.countKo1 = data.countKo1 || 0;
    this.countKo2 = data.countKo2 || 0;
    this.keikaDate = data.keikaDate || null;
    this.serviceRiyo = data.serviceRiyo || 0;
    this.userCnt = data.userCnt || 0;
    this.jigyoshoGen = data.jigyoshoGen || 0;
    this.serviceGaibu = data.serviceGaibu || 0;
    this.jigyoshoDai = data.jigyoshoDai || 0;
    this.needSien1 = data.needSien1 || 0;
    this.needSien2 = data.needSien2 || 0;
    this.homonJigyoKbn = data.homonJigyoKbn || 0;
    this.terminalKbn = data.terminalKbn || 0;
    this.eiyoKbn = data.eiyoKbn || 0;
    this.koukouKbn = data.koukouKbn || 0;
    this.jakunenKbn = data.jakunenKbn || 0;
    this.ukeireKbn = data.ukeireKbn || 0;
    this.yakanKbn = data.yakanKbn || 0;
    this.jigyoshoKasan = data.jigyoshoKasan || 0;
    this.unitcareKbn = data.unitcareKbn || 0;
    this.judoKbn = data.judoKbn || 0;
    this.junUnitKbn = data.junUnitKbn || 0;
    this.yobi159 = data.yobi159 || 0;
    this.kosokuHaisiKbn = data.kosokuHaisiKbn || 0;
    this.sogoRiyoKbn = data.sogoRiyoKbn || 0;
    this.undoKbn = data.undoKbn || 0;
    this.jigyoHyokaKbn = data.jigyoHyokaKbn || 0;
    this.renkeiKbn = data.renkeiKbn || 0;
    this.shokiboKbn = data.shokiboKbn || 0;
    this.kasanCode21 = data.kasanCode21 || "";
    this.kasanCode22 = data.kasanCode22 || "";
    this.kasanCode23 = data.kasanCode23 || "";
    this.kasanCode24 = data.kasanCode24 || "";
    this.kasanCode25 = data.kasanCode25 || "";
    this.kasanCode26 = data.kasanCode26 || "";
    this.kasanCode27 = data.kasanCode27 || "";
    this.kasanCode28 = data.kasanCode28 || "";
    this.kasanCode29 = data.kasanCode29 || "";
    this.kasanCode30 = data.kasanCode30 || "";
    this.seiyakuKbn = data.seiyakuKbn || 0;
    this.serviceKbn = data.serviceKbn || 0;
    this.hiwariKbn = data.hiwariKbn || 0;
    this.yobi179 = data.yobi179 || 0;
    this.nintiCareKbn = data.nintiCareKbn || 0;
    this.kunrenKbn = data.kunrenKbn || 0;
    this.homonNinzu = data.homonNinzu || 0;
    this.siKasan1 = data.siKasan1 || 0;
    this.keiTani1 = data.keiTani1 || 0;
    this.siKasan2 = data.siKasan2 || 0;
    this.keiTani2 = data.keiTani2 || 0;
    this.siKasan3 = data.siKasan3 || 0;
    this.keiTani3 = data.keiTani3 || 0;
    this.setubi = data.setubi || "";
    this.ryoyoToku = data.ryoyoToku || "";
    this.kasanCode31 = data.kasanCode31 || "";
    this.kasanCode32 = data.kasanCode32 || "";
    this.kasanCode33 = data.kasanCode33 || "";
    this.kasanCode34 = data.kasanCode34 || "";
    this.kasanCode35 = data.kasanCode35 || "";
    this.kasanCode36 = data.kasanCode36 || "";
    this.kasanCode37 = data.kasanCode37 || "";
    this.kasanCode38 = data.kasanCode38 || "";
    this.kasanCode39 = data.kasanCode39 || "";
    this.kasanCode40 = data.kasanCode40 || "";
    this.kasanCode41 = data.kasanCode41 || "";
    this.kasanCode42 = data.kasanCode42 || "";
    this.kasanCode43 = data.kasanCode43 || "";
    this.kasanCode44 = data.kasanCode44 || "";
    this.kasanCode45 = data.kasanCode45 || "";
    this.sankyuTaisei = data.sankyuTaisei || "";
    this.tikiJokyo = data.tikiJokyo || "";
    this.kiboJokyo = data.kiboJokyo || "";
    this.teikyoTaisei = data.teikyoTaisei || "";
    this.ninchiRiha = data.ninchiRiha || "";
    this.jyakunensei = data.jyakunensei || "";
    this.kangoTaisei = data.kangoTaisei || "";
    this.yakinHaichi = data.yakinHaichi || "";
    this.ryoyoshoku = data.ryoyoshoku || "";
    this.yobi215 = data.yobi215 || "";
    this.yobi216 = data.yobi216 || "";
    this.keizokuSien = data.keizokuSien || "";
    this.ninchiCare = data.ninchiCare || "";
    this.tuhoTaio = data.tuhoTaio || "";
    this.kangoHaichi = data.kangoHaichi || "";
    this.yakanKea = data.yakanKea || "";
    this.chuzanTeikyo = data.chuzanTeikyo || "";
    this.siKasan4 = data.siKasan4 || 0;
    this.keiTani4 = data.keiTani4 || 0;
    this.siKasan5 = data.siKasan5 || 0;
    this.keiTani5 = data.keiTani5 || 0;
    this.siKasan6 = data.siKasan6 || 0;
    this.keiTani6 = data.keiTani6 || 0;
    this.siKasan7 = data.siKasan7 || 0;
    this.keiTani7 = data.keiTani7 || 0;
    this.siKasan8 = data.siKasan8 || 0;
    this.keiTani8 = data.keiTani8 || 0;
    this.siKasan9 = data.siKasan9 || 0;
    this.keiTani9 = data.keiTani9 || 0;
    this.siKasan10 = data.siKasan10 || 0;
    this.keiTani10 = data.keiTani10 || 0;
    this.dokujiHoshu = data.dokujiHoshu || 0;
    this.jogenTani = data.jogenTani || 0;
    this.kasanCode46 = data.kasanCode46 || "";
    this.kasanCode47 = data.kasanCode47 || "";
    this.kasanCode48 = data.kasanCode48 || "";
    this.kasanCode49 = data.kasanCode49 || "";
    this.kasanCode50 = data.kasanCode50 || "";
    this.kasanCode51 = data.kasanCode51 || "";
    this.kasanCode52 = data.kasanCode52 || "";
    this.kasanCode53 = data.kasanCode53 || "";
    this.kasanCode54 = data.kasanCode54 || "";
    this.kasanCode55 = data.kasanCode55 || "";
    this.sekininsha = data.sekininsha || "";
    this.kinkyuTanki = data.kinkyuTanki || "";
    this.yobi251 = data.yobi251 || "";
    this.fukkiSien = data.fukkiSien || "";
    this.kinoKojo = data.kinoKojo || "";
    this.shogu = data.shogu || "";
    this.miman = data.miman || "";
    this.tatemono = data.tatemono || "";
    this.shoguTani = data.shoguTani || 0;
    this.shoguKbn = data.shoguKbn || "";
    this.sogoJigyoRuikei = data.sogoJigyoRuikei || "";
    this.hiHokenSogoTaisyo = data.hiHokenSogoTaisyo || "";
    this.sogoJigyoKbn = data.sogoJigyoKbn || "";
    this.sogoJigyoHenKbn = data.sogoJigyoHenKbn || "";
    this.sogoJigyoFutanKbn = data.sogoJigyoFutanKbn || "";
    this.rihaMgKbn = data.rihaMgKbn || "";
    this.kangoTaiseiKbn = data.kangoTaiseiKbn || "";
    this.tankiRihaKbn = data.tankiRihaKbn || "";
    this.syakaiSankaKbn = data.syakaiSankaKbn || "";
    this.nintishoKasanKbn = data.nintishoKasanKbn || "";
    this.chudosyaCareKbn = data.chudosyaCareKbn || "";
    this.kobetuSogeiKbn = data.kobetuSogeiKbn || "";
    this.nyuyokuKaijyoKbn = data.nyuyokuKaijyoKbn || "";
    this.yob272 = data.yob272 || "";
    this.seikatuKouiKbn = data.seikatuKouiKbn || "";
    this.yob274 = data.yob274 || "";
    this.yob275 = data.yob275 || "";
    this.iryoRenkei = data.iryoRenkei || "";
    this.yob277 = data.yob277 || "";
    this.tokuteiGenKbn = data.tokuteiGenKbn || "";
    this.yob279 = data.yob279 || "";
    this.yob280 = data.yob280 || "";
    this.yob281 = data.yob281 || "";
    this.yob282 = data.yob282 || "";
    this.yob283 = data.yob283 || "";
    this.sentakuHukuKbn = data.sentakuHukuKbn || "";
    this.sogoMgKbn = data.sogoMgKbn || "";
    this.yob286 = data.yob286 || "";
    this.yob287 = data.yob287 || "";
    this.mitoriKbn = data.mitoriKbn || "";
    this.homonTaiseiKbn = data.homonTaiseiKbn || "";
    this.yakanTaiseiKbn = data.yakanTaiseiKbn || "";
    this.kangoGenKbn = data.kangoGenKbn || "";
    this.kangoKyokaKbn = data.kangoKyokaKbn || "";
    this.yob293 = data.yob293 || "";
    this.yob294 = data.yob294 || "";
    this.yob295 = data.yob295 || "";
    this.yob296 = data.yob296 || "";
    this.yob297 = data.yob297 || "";
    this.yob298 = data.yob298 || "";
    this.yob299 = data.yob299 || "";
    this.yob300 = data.yob300 || "";
    this.douituGen = data.douituGen || "";
    this.pkSystemCode = data.pkSystemCode || 0;
    this.isSelect = data.isSelect || false;
  }

  clear(): void {
    this.pkCompanyCode = "";
    this.pkOfficeCode = "";
    this.pkServiceType = "";
    this.serviceType = "";
    this.serviceCode = "";
    this.serviceName = "";
    this.serviceId = 0;
    this.hokenCode = "";
    this.memo = "";
    this.kaisibi = "";
    this.shuryobi = "";
    this.serviceCount = 0;
    this.serviceRyaku = "";
    this.henkobi = null;
    this.newServiceCount = 0;
    this.santeiTime = 0;
    this.countKbn = 0;
    this.newServiceName = "";
    this.countSantei = 0;
    this.kizamiLow = 0;
    this.goseiKbn = 0;
    this.kizamiHigh = 0;
    this.kizamiHaba = 0;
    this.kizamiTani = 0;
    this.kizamiCount = 0;
    this.yobi1 = "";
    this.yobi2 = "";
    this.yobi3 = "";
    this.yobi4 = "";
    this.yobi5 = "";
    this.sisetuKbn = "";
    this.shokuinKbn = 0;
    this.gaitoKbn = 0;
    this.keikaKaigo = 0;
    this.kaigoRank1 = 0;
    this.kaigoRank2 = 0;
    this.kaigoRank3 = 0;
    this.kaigoRank4 = 0;
    this.kaigoRank5 = 0;
    this.kyusotiKbn = 0;
    this.hihokenKbn1 = "";
    this.hihokenKbn2 = "";
    this.hihokenKbn3 = "";
    this.hihokenKbn4 = "";
    this.hihokenKbn5 = "";
    this.naiyoKbn = 0;
    this.sikakuKbn = "";
    this.shoyoJikans = 0;
    this.shoyoJikane = 0;
    this.baseCode = "";
    this.chukagenCode1 = "";
    this.chukagenCode2 = "";
    this.chukagenCode3 = "";
    this.chukagenCode4 = "";
    this.chukagenCode5 = "";
    this.chukagenCode6 = "";
    this.chukagenCode7 = "";
    this.chukagenCode8 = "";
    this.chukagenCode9 = "";
    this.chukagenCode10 = "";
    this.chukagenYobi1 = "";
    this.chukagenYobi2 = "";
    this.chukagenYobi3 = "";
    this.chukagenYobi4 = "";
    this.chukagenYobi5 = "";
    this.chukagenYobi6 = "";
    this.chukagenYobi7 = "";
    this.chukagenYobi8 = "";
    this.chukagenYobi9 = "";
    this.chukagenYobi10 = "";
    this.kasanCode1 = "";
    this.kasanCode2 = "";
    this.kasanCode3 = "";
    this.kasanCode4 = "";
    this.kasanCode5 = "";
    this.kasanCode6 = "";
    this.kasanCode7 = "";
    this.kasanCode8 = "";
    this.kasanCode9 = "";
    this.kasanCode10 = "";
    this.kasanYobi1 = "";
    this.kasanYobi2 = "";
    this.kasanYobi3 = "";
    this.kasanYobi4 = "";
    this.kasanYobi5 = "";
    this.kasanYobi6 = "";
    this.kasanYobi7 = "";
    this.kasanYobi8 = "";
    this.kasanYobi9 = "";
    this.kasanYobi10 = "";
    this.tekiyoJoken = 0;
    this.gendotaishoKbn = 0;
    this.santeiJiki = 0;
    this.santeiNissu = 0;
    this.tikiKbn = 0;
    this.kinkyuKbn = 0;
    this.kanriKbn = 0;
    this.kinoKbn = 0;
    this.shokujiKbn = 0;
    this.nyuyokuKbn = 0;
    this.tokuNyoyokuKbn = 0;
    this.rihaKbn = 0;
    this.kijunKbn = 0;
    this.h10Kbn = 0;
    this.jokinDoctor = 0;
    this.kinmuKbn = 0;
    this.doctorKeika = 0;
    this.seisinShodo = 0;
    this.yakinKbn = 0;
    this.tihotoKbn = 0;
    this.shokujiKanri = 0;
    this.tokuShokujiKbn = 0;
    this.sogeiKbn = 0;
    this.jigyoSiteiYobi1 = 0;
    this.jigyoSiteiYobi2 = 0;
    this.jigyoSiteiYobi3 = 0;
    this.jigyoSiteiYobi4 = 0;
    this.jigyoSiteiYobi5 = 0;
    this.jigyoSiteiYobi6 = 0;
    this.jigyoSiteiYobi7 = 0;
    this.jigyoSiteiYobi8 = 0;
    this.jigyoSiteiYobi9 = 0;
    this.jigyoSiteiYobi10 = 0;
    this.kohiBango1 = 0;
    this.kohiBango2 = 0;
    this.kohiBango3 = 0;
    this.kohiBango4 = 0;
    this.kohiBango5 = 0;
    this.kohiBango6 = 0;
    this.kohiBango7 = 0;
    this.kohiBango8 = 0;
    this.kohiBango9 = 0;
    this.kohiBango10 = 0;
    this.kohiYobi1 = 0;
    this.kohiYobi2 = 0;
    this.kohiYobi3 = 0;
    this.kohiYobi4 = 0;
    this.kohiYobi5 = 0;
    this.kohiYobi6 = 0;
    this.kohiYobi7 = 0;
    this.kohiYobi8 = 0;
    this.kohiYobi9 = 0;
    this.kohiYobi10 = 0;
    this.countSho = 0;
    this.countBu = "";
    this.countEda = "";
    this.countSetu = "";
    this.countKo1 = 0;
    this.countKo2 = 0;
    this.keikaDate = null;
    this.serviceRiyo = 0;
    this.userCnt = 0;
    this.jigyoshoGen = 0;
    this.serviceGaibu = 0;
    this.jigyoshoDai = 0;
    this.needSien1 = 0;
    this.needSien2 = 0;
    this.homonJigyoKbn = 0;
    this.terminalKbn = 0;
    this.eiyoKbn = 0;
    this.koukouKbn = 0;
    this.jakunenKbn = 0;
    this.ukeireKbn = 0;
    this.yakanKbn = 0;
    this.jigyoshoKasan = 0;
    this.unitcareKbn = 0;
    this.judoKbn = 0;
    this.junUnitKbn = 0;
    this.yobi159 = 0;
    this.kosokuHaisiKbn = 0;
    this.sogoRiyoKbn = 0;
    this.undoKbn = 0;
    this.jigyoHyokaKbn = 0;
    this.renkeiKbn = 0;
    this.shokiboKbn = 0;
    this.kasanCode21 = "";
    this.kasanCode22 = "";
    this.kasanCode23 = "";
    this.kasanCode24 = "";
    this.kasanCode25 = "";
    this.kasanCode26 = "";
    this.kasanCode27 = "";
    this.kasanCode28 = "";
    this.kasanCode29 = "";
    this.kasanCode30 = "";
    this.seiyakuKbn = 0;
    this.serviceKbn = 0;
    this.hiwariKbn = 0;
    this.yobi179 = 0;
    this.nintiCareKbn = 0;
    this.kunrenKbn = 0;
    this.homonNinzu = 0;
    this.siKasan1 = 0;
    this.keiTani1 = 0;
    this.siKasan2 = 0;
    this.keiTani2 = 0;
    this.siKasan3 = 0;
    this.keiTani3 = 0;
    this.setubi = "";
    this.ryoyoToku = "";
    this.kasanCode31 = "";
    this.kasanCode32 = "";
    this.kasanCode33 = "";
    this.kasanCode34 = "";
    this.kasanCode35 = "";
    this.kasanCode36 = "";
    this.kasanCode37 = "";
    this.kasanCode38 = "";
    this.kasanCode39 = "";
    this.kasanCode40 = "";
    this.kasanCode41 = "";
    this.kasanCode42 = "";
    this.kasanCode43 = "";
    this.kasanCode44 = "";
    this.kasanCode45 = "";
    this.sankyuTaisei = "";
    this.tikiJokyo = "";
    this.kiboJokyo = "";
    this.teikyoTaisei = "";
    this.ninchiRiha = "";
    this.jyakunensei = "";
    this.kangoTaisei = "";
    this.yakinHaichi = "";
    this.ryoyoshoku = "";
    this.yobi215 = "";
    this.yobi216 = "";
    this.keizokuSien = "";
    this.ninchiCare = "";
    this.tuhoTaio = "";
    this.kangoHaichi = "";
    this.yakanKea = "";
    this.chuzanTeikyo = "";
    this.siKasan4 = 0;
    this.keiTani4 = 0;
    this.siKasan5 = 0;
    this.keiTani5 = 0;
    this.siKasan6 = 0;
    this.keiTani6 = 0;
    this.siKasan7 = 0;
    this.keiTani7 = 0;
    this.siKasan8 = 0;
    this.keiTani8 = 0;
    this.siKasan9 = 0;
    this.keiTani9 = 0;
    this.siKasan10 = 0;
    this.keiTani10 = 0;
    this.dokujiHoshu = 0;
    this.jogenTani = 0;
    this.kasanCode46 = "";
    this.kasanCode47 = "";
    this.kasanCode48 = "";
    this.kasanCode49 = "";
    this.kasanCode50 = "";
    this.kasanCode51 = "";
    this.kasanCode52 = "";
    this.kasanCode53 = "";
    this.kasanCode54 = "";
    this.kasanCode55 = "";
    this.sekininsha = "";
    this.kinkyuTanki = "";
    this.yobi251 = "";
    this.fukkiSien = "";
    this.kinoKojo = "";
    this.shogu = "";
    this.miman = "";
    this.tatemono = "";
    this.shoguTani = 0;
    this.shoguKbn = "";
    this.sogoJigyoRuikei = "";
    this.hiHokenSogoTaisyo = "";
    this.sogoJigyoKbn = "";
    this.sogoJigyoHenKbn = "";
    this.sogoJigyoFutanKbn = "";
    this.rihaMgKbn = "";
    this.kangoTaiseiKbn = "";
    this.tankiRihaKbn = "";
    this.syakaiSankaKbn = "";
    this.nintishoKasanKbn = "";
    this.chudosyaCareKbn = "";
    this.kobetuSogeiKbn = "";
    this.nyuyokuKaijyoKbn = "";
    this.yob272 = "";
    this.seikatuKouiKbn = "";
    this.yob274 = "";
    this.yob275 = "";
    this.iryoRenkei = "";
    this.yob277 = "";
    this.tokuteiGenKbn = "";
    this.yob279 = "";
    this.yob280 = "";
    this.yob281 = "";
    this.yob282 = "";
    this.yob283 = "";
    this.sentakuHukuKbn = "";
    this.sogoMgKbn = "";
    this.yob286 = "";
    this.yob287 = "";
    this.mitoriKbn = "";
    this.homonTaiseiKbn = "";
    this.yakanTaiseiKbn = "";
    this.kangoGenKbn = "";
    this.kangoKyokaKbn = "";
    this.yob293 = "";
    this.yob294 = "";
    this.yob295 = "";
    this.yob296 = "";
    this.yob297 = "";
    this.yob298 = "";
    this.yob299 = "";
    this.yob300 = "";
    this.douituGen = "";
    this.pkSystemCode = 0;
    this.isSelect = false;
  }
}

type SelectedActionServiceCodeSearchCallback = (item: any) => void;
type SelectedActionMultiServiceCodeSearchCallback = (item: any) => void;

export function useServiceCodeSearch() {
  const ServiceCodeSearchId: string = "myServiceCodeSearchId";
  const isModalServiceCodeSearchVisible: Ref<boolean> = ref(false);
  const selectedActionServiceCodeSearchCallback: Ref<SelectedActionServiceCodeSearchCallback | null> =
    ref(null);
  const selectedActionMultiServiceCodeSearchCallback: Ref<SelectedActionMultiServiceCodeSearchCallback | null> =
    ref(null);

  async function showServiceCodeSearch(
    callback: SelectedActionServiceCodeSearchCallback,
    callback2: SelectedActionServiceCodeSearchCallback
  ): Promise<void> {
    isModalServiceCodeSearchVisible.value = true;
    selectedActionServiceCodeSearchCallback.value = callback;
    selectedActionMultiServiceCodeSearchCallback.value = callback2;
  }

  async function closeModalServiceCodeSearch(): Promise<void> {
    isModalServiceCodeSearchVisible.value = false;
  }

  async function selectedActionServiceCodeSearch(item: any): Promise<void> {
    if (selectedActionServiceCodeSearchCallback.value) {
      selectedActionServiceCodeSearchCallback.value(item); // コールバックにユーザーを渡す
    }
    await closeModalServiceCodeSearch();
  }

  async function selectedActionMultiServiceCodeSearch(
    item: any
  ): Promise<void> {
    if (selectedActionMultiServiceCodeSearchCallback.value) {
      selectedActionMultiServiceCodeSearchCallback.value(item); // コールバックにユーザーを渡す
    }
    await closeModalServiceCodeSearch();
  }

  function cancelActionServiceCodeSearch(): void {
    closeModalServiceCodeSearch();
  }

  return {
    ServiceCodeSearchId,
    isModalServiceCodeSearchVisible,
    showServiceCodeSearch,
    closeModalServiceCodeSearch,
    cancelActionServiceCodeSearch,
    selectedActionServiceCodeSearch,
    selectedActionMultiServiceCodeSearch,
  };
}

export interface ITblMServiceCSVData {
  year?: number;
  month?: number;
  serviceType?: string;
  serviceTypeName?: string;
  url?: string | any;
}

export class TblMServiceCSV {
  year?: number;
  month?: number;
  serviceType?: string;
  serviceTypeName?: string;
  url?: string | any;

  constructor(data: ITblMServiceCSVData = {}) {
    this.year = data.year || 0;
    this.month = data.month || 0;
    this.serviceType = data.serviceType || "";
    this.serviceTypeName = data.serviceTypeName || "";
    this.url = data.url || "";
  }

}
